var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 0C51.6508 0 48.125 3.52576 48.125 7.875V104.125C48.125 108.474 51.6508 112 56 112C60.3492 112 63.875 108.474 63.875 104.125V7.875C63.875 3.52576 60.3492 0 56 0Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0625 35.875C24.0625 31.5258 27.5883 28 31.9375 28C36.2867 28 39.8125 31.5258 39.8125 35.875V76.125C39.8125 80.4742 36.2867 84 31.9375 84C27.5883 84 24.0625 80.4742 24.0625 76.125V35.875Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 49.875C0 45.5258 3.52576 42 7.875 42C12.2242 42 15.75 45.5258 15.75 49.875V62.125C15.75 66.4742 12.2242 70 7.875 70C3.52576 70 0 66.4742 0 62.125V49.875Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1875 25.375C72.1875 21.0258 75.7133 17.5 80.0625 17.5C84.4117 17.5 87.9375 21.0258 87.9375 25.375V86.625C87.9375 90.9742 84.4117 94.5 80.0625 94.5C75.7133 94.5 72.1875 90.9742 72.1875 86.625V25.375Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.125 63.875C108.474 63.875 112 60.3492 112 56C112 51.6508 108.474 48.125 104.125 48.125C99.7758 48.125 96.25 51.6508 96.25 56C96.25 60.3492 99.7758 63.875 104.125 63.875Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandLoader);
export default __webpack_public_path__ + "static/media/brand-loader.c3e4f9baba6ea29abb0694efd4fa1d30.svg";
export { ForwardRef as ReactComponent };